module.exports = __webpack_public_path__ + "img/percentagePreview.5f50da2.png";